import { render, staticRenderFns } from "./CompleteCart.vue?vue&type=template&id=b1afdbe2&scoped=true&"
var script = {}
import style0 from "./CompleteCart.vue?vue&type=style&index=0&id=b1afdbe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1afdbe2",
  null
  
)

export default component.exports